<template>
  <ExpansibleColumn id="step-2" class="flex-none py-1 sm:pt-2 lg:pb-10">
    <template #default="{ collapsed }">
      <TableOfContents
        v-if="legalText"
        class="min-h-0"
        :legalTextParagraph="legalTextParagraph"
        :nestedToc="nestedData"
        :flatToc="toc"
        :legalText="legalText"
        :parentsOfActiveParagraph="parentsOfActiveParagraph"
        :columnCollapsed="collapsed"
        :bookmarks="bookmarks ?? []"
        :loading="tocLoading"
      />
      <LinksOverview
        v-if="(legalTextParagraph || paragraphLoading) && !showcase"
        class="min-h-0 max-lg:hidden"
        :legalText="legalText"
        :legalTextParagraph="legalTextParagraph"
        :paragraphLoading="paragraphLoading"
        :columnCollapsed="collapsed"
      />

      <!-- Mobile Buttons -->
      <WorkspaceMobileDialogButtons
        v-if="!showcase"
        class="justify-end lg:hidden"
        :collapsed
        :legalText="legalText"
        :sortedNotes="sortedNotes"
        :legalTextParagraph="legalTextParagraph"
        :paragraphFol="fieldOfLaw"
        :activeEntrySlug="activeEntrySlug"
        :paragraphLoading="paragraphLoading"
      />
    </template>
  </ExpansibleColumn>
</template>

<script lang="ts" setup>
import type { IFieldOfLaw } from "~/models/IFieldOfLaw";
import type { ILegalText } from "~/models/ILegalText";
import type {
  IBookmark,
  ILegalTextParagraph,
} from "~/models/ILegalTextParagraph";
import type { IToC } from "~/models/IToC";
import type { INote } from "~/models/IUserEntry";

type Props = {
  legalText: ILegalText | undefined;
  legalTextParagraph: ILegalTextParagraph | undefined;
  paragraphLoading: boolean;
  fieldOfLaw: IFieldOfLaw | undefined;
  activeEntrySlug: string;
  bookmarks: IBookmark[] | undefined;
  toc: (ILegalTextParagraph | IToC)[] | undefined;
  nestedData: IToC[] | undefined;
  tocLoading: boolean;
  sortedNotes: INote[];
  parentsOfActiveParagraph: IToC[];
};

defineProps<Props>();

const showcase = useExamShowcase();
</script>
